'use client'

import { useRouter } from 'nextjs-toploader/app'
import Typography from './ui/Typography'

function MainTitle() {
  const router = useRouter()
  return (
    <Typography
      onClick={() => router.push('/')}
      className='mb-4 cursor-pointer font-nastaliq md:text-[36px] text-[32px] text-primary'
      center
    >
      ختم اذکار و قرآن مدرسه تعالی
    </Typography>
  )
}

export default MainTitle
